import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  selectHeader: 'Select your preferred resolution:',
  tip: 'Some resolutions may not be available based on the quality of your uploaded video.',
  tip2: 'To access higher resolutions, the original video needs to be of higher quality.',
  tip3: 'Please ensure your video has sound before uploading. Silent videos will not process correctly.',
  videoUploaded: 'File uploaded successfully',
  fileName: 'Selected file: ',
  upload: 'Start upload',
  uploadingFile: 'Review your upload',
  fileStep: (position: number, total: number) =>
    `Video ${position} of ${total}`,
  next: 'Next video',
  back: 'Previous video',
};

const welsh = {
  selectHeader: 'Dewiswch resolfa darged ar gyfer eich fideo',
  tip: 'Efallai na fydd rhai resolfeydd ar gael yn seiliedig ar y fideo a lwythwyd gennych.',
  tip2: "I gael gafael ar resolfeydd uwch, mae angen i'r fideo gwreiddiol fod o ansawdd uwch.",
  tip3: 'Please ensure your video has sound before uploading. Silent videos will not process correctly.',
  videoUploaded: "Mae'r ffeil wedi'i llwytho i fyny'n llwyddiannus",
  fileName: 'Ffeil a ddewiswyd',
  upload: 'Llwythwch i fyny',
  uploadingFile: 'Adolygwch eich llwythiad',
  fileStep: (position: number, total: number) => `Fideo ${position} o ${total}`,
  next: 'Fideo nesaf',
  back: 'Fideo blaenorol',
};

export const fileUploadText: any = getLocalizationBasedOnLang(english, welsh);
